module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "c-related-posts"
  }, [(_vm.prevPost) ? _c('router-link', {
    class: ("c-related-post__btn c-related-post__btn--previous c-related-post__btn--" + (_vm.toCssName(_vm.prevPost.data.category))),
    attrs: {
      "to": {
        name: 'post',
        params: {
          id: _vm.prevPost.uid
        }
      }
    }
  }, [_c('span', {
    staticClass: "c-related-post__btn-text"
  }, [_vm._v("Read Previous")]), _vm._v(" "), _c('div', {
    staticClass: "c-related-post__content"
  }, [_c('h5', {
    staticClass: "c-related-post__meta-category",
    domProps: {
      "innerHTML": _vm._s(_vm.prevPost.data.category)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-related-post__title-wrapper"
  }, [_c('h4', {
    staticClass: "c-related-post__title"
  }, [_vm._v(_vm._s(_vm.getTextContent(_vm.prevPost.data.title)))])])])]) : _vm._e(), _vm._v(" "), (_vm.nextPost) ? _c('router-link', {
    class: ("c-related-post__btn c-related-post__btn--next c-related-post__btn--" + (_vm.toCssName(_vm.nextPost.data.category))),
    attrs: {
      "to": {
        name: 'post',
        params: {
          id: _vm.nextPost.uid
        }
      }
    }
  }, [_c('span', {
    staticClass: "c-related-post__btn-text"
  }, [_vm._v("Read Next")]), _vm._v(" "), _c('div', {
    staticClass: "c-related-post__content"
  }, [_c('h5', {
    staticClass: "c-related-post__meta-category",
    domProps: {
      "innerHTML": _vm._s(_vm.nextPost.data.category)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-related-post__title-wrapper"
  }, [_c('h4', {
    staticClass: "c-related-post__title"
  }, [_vm._v(_vm._s(_vm.getTextContent(_vm.nextPost.data.title)))])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28c993a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RelatedPosts.vue
// module id = 75
// module chunks = 0